/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Checkout_Verifying_TitleInputs */

const en_creator_checkout_verifying_title = /** @type {(inputs: Creator_Checkout_Verifying_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifying Subscription`)
};

const fr_creator_checkout_verifying_title = /** @type {(inputs: Creator_Checkout_Verifying_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification de l'abonnement`)
};

const de_creator_checkout_verifying_title = /** @type {(inputs: Creator_Checkout_Verifying_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement wird überprüft`)
};

const it_creator_checkout_verifying_title = /** @type {(inputs: Creator_Checkout_Verifying_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica dell'abbonamento`)
};

const ru_creator_checkout_verifying_title = /** @type {(inputs: Creator_Checkout_Verifying_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка подписки`)
};

const es_creator_checkout_verifying_title = /** @type {(inputs: Creator_Checkout_Verifying_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando suscripción`)
};

const zh_cn2_creator_checkout_verifying_title = /** @type {(inputs: Creator_Checkout_Verifying_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证订阅`)
};

const ja_creator_checkout_verifying_title = /** @type {(inputs: Creator_Checkout_Verifying_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションの確認`)
};

const hi_creator_checkout_verifying_title = /** @type {(inputs: Creator_Checkout_Verifying_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता सत्यापित हो रही है`)
};

const pt_pt2_creator_checkout_verifying_title = /** @type {(inputs: Creator_Checkout_Verifying_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando assinatura`)
};

/**
* | output |
* | --- |
* | "Verifying Subscription" |
*
* @param {Creator_Checkout_Verifying_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_verifying_title = /** @type {((inputs?: Creator_Checkout_Verifying_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Verifying_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_checkout_verifying_title(inputs)
	if (locale === "de") return de_creator_checkout_verifying_title(inputs)
	if (locale === "it") return it_creator_checkout_verifying_title(inputs)
	if (locale === "ru") return ru_creator_checkout_verifying_title(inputs)
	if (locale === "es") return es_creator_checkout_verifying_title(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_checkout_verifying_title(inputs)
	if (locale === "ja") return ja_creator_checkout_verifying_title(inputs)
	if (locale === "hi") return hi_creator_checkout_verifying_title(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_checkout_verifying_title(inputs)
	return en_creator_checkout_verifying_title(inputs)
});